export const PROMOS = [
  {
    code: 'LFDI10',
    startDate: '2026-05-22T09:31:00+02:00',
    endDate: '2026-05-31T23:59:00+02:00',
    label: '-10% sur toute la commande',
    minItems: 1,
  },
  {
    code: 'PROMO2/20',
    startDate: '2026-06-01T00:00:00+02:00',
    endDate: '2026-06-14T23:59:00+02:00',
    label: '-20% sur toute la commande',
    minItems: 2,
    hintDiscount: '-20%',
  },
];

const isPromoInDateRange = (promo, now = new Date()) => {
  if (!promo.code || !promo.startDate || !promo.endDate) return false;

  const start = new Date(promo.startDate);
  const end = new Date(promo.endDate);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;

  return now >= start && now <= end;
};

export const getActivePromo = () =>
  PROMOS.find((promo) => isPromoInDateRange(promo)) ?? null;

/** @deprecated Préférer getActivePromo() pour la promo courante selon les dates. */
export const PROMO = PROMOS[0];

export const isPromoActive = () => getActivePromo() !== null;

export const shouldApplyPromoDiscount = (itemCount) => {
  const promo = getActivePromo();
  if (!promo) return false;

  const minItems = promo.minItems ?? 1;
  return itemCount >= minItems;
};

const getPromoDiscountPercent = (promo) => {
  if (promo.discountPercent) return promo.discountPercent;

  const source = promo.hintDiscount ?? promo.label ?? '';
  const match = source.match(/(\d+)\s*%/);
  return match ? `${match[1]}%` : source;
};

export const getPromoBannerLabel = (promo) => {
  const percent = getPromoDiscountPercent(promo);
  const minItems = promo.minItems ?? 1;

  if (minItems > 1) {
    return `Profitez de ${percent} de réduction à l'achat d'au moins ${minItems} articles`;
  }

  return `Profitez de ${percent} de réduction sur toute la commande`;
};

export const getPromoMinItemsHint = (itemCount) => {
  const promo = getActivePromo();
  if (!promo) return null;

  const minItems = promo.minItems ?? 1;
  if (itemCount >= minItems || itemCount <= 0) return null;

  const remaining = minItems - itemCount;
  const percent = getPromoDiscountPercent(promo);
  const articleWord = remaining === 1 ? 'article' : 'articles';

  return `Ajoutez ${remaining} ${articleWord} supplémentaire${remaining > 1 ? 's' : ''} pour profiter de ${percent} de réduction`;
};
